/*
 * The changelog. Same reading column and rhythm as ContactPage and LegalPage, so the prose
 * pages of this site look like one another. The three pills are outlined in ink or the
 * rule colour: no accent, like everything else here.
 */

.article {
  padding-block: clamp(38px, 6vw, 68px) clamp(40px, 6vw, 72px);
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.back {
  font-size: 14px;
  color: var(--ink-muted);
  align-self: flex-start;
  padding-block: 8px;
}

.back:hover {
  color: var(--ink);
}

.title {
  margin-top: 8px;
  font-size: clamp(34px, 5vw, 48px);
  line-height: 1.1;
  color: var(--ink);
}

.lede {
  margin-top: 6px;
  font-family: var(--font-display);
  font-size: 18px;
  line-height: 1.6;
  color: var(--ink-body);
}

.list {
  list-style: none;
  margin-top: 14px;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.entry {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 24px;
  border-top: 1px solid var(--rule);
}

.meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: var(--ink-muted);
}

/* Shared pill shape for the three meta labels. */
.version,
.unreleased,
.area {
  border-radius: 999px;
  padding: 2px 10px;
  border: 1px solid var(--rule);
  font-size: 13px;
}

.version {
  color: var(--ink);
  border-color: var(--ink);
}

.unreleased {
  border-style: dashed;
}

.entryTitle {
  font-size: 24px;
  color: var(--ink);
}

.description {
  font-size: 16px;
  line-height: 1.7;
  color: var(--ink-muted);
}
